<template> 
  <div class="flex flex-col gap-4 w-full">
    <Card class="max-w-[800px] mx-full">
    <!-- <Card class="card sm:w-64"> -->
      <template #title>Общая информация</template>
      <template #content>
        <div class="flex flex-col gap-2">
          <p>
            <span class="text-surface-500 dark:text-surface-400">Name: </span>
            <span class="text-surface-800 dark:text-surface-700">{{ userInfo.name }}</span>
          </p>
          <p>
            <span class="text-surface-500 dark:text-surface-400">Логин: </span>
            <span class="text-surface-800 dark:text-surface-700">{{ userInfo.login }}</span>
          </p>
          <p>
            <span class="text-surface-500 dark:text-surface-400">Email: </span>
            <span class="text-surface-800 dark:text-surface-700">{{ userInfo.email }}</span>
          </p>              
        </div>
        <Button label="Изменить пароль" @click="changePasswordVisibility" />        
        <Dialog v-model:visible="isPasswordVisible" modal header="Изменение пароля" :style="{ width: '25rem' }">
        <div v-if="isPasswordVisible" class="w-full max-w-[360px] flex flex-col items-center gap-2 p-4">          
          <div class="flex flex-col gap-2 mt-2">            
            <label for="password">Введите новый пароль:</label>
            <Password 
              v-model="password"             
              inputId="password"                 
              @input="validatePasswords" 
              :invalid="isValidationError"
              :feedback="false" 
              variant="filled" 
              :inputProps="{ disabled: loading }" 
              toggleMask 
              class="relative"
            />                          
            <label for="confirmPassword">Повторите пароль:</label>
            <Password 
              v-model="confirmPassword"             
              inputId="confirmPassword"                  
              @input="inputConfirmPassword" 
              :invalid="isValidationError"
              :feedback="false" variant="filled" 
              :inputProps="{ disabled: loading }" 
              toggleMask 
              class="relative"
            />            
          </div>
          <div class="flex gap-2 mt-2">            
            <Message severity="error" size="small" variant="simple" class="mb-2">{{ passwordValidateError }}</Message>
          </div>        
          <div class="flex gap-2 mt-2">
            <Button label="Сохранить" :disabled="loading" @click="changePassword" />
            <Button label="Отменить" :disabled="loading" @click="undoPasswordChange" />
          </div>
        </div>       
        </Dialog> 
      </template>
    </Card>
  </div>
</template>

<script>
import { AuthService } from '@/services/auth.service'
import { UsersService } from '@/services/users.service'
import { ClubsService } from '@/services/clubs.service'
import Card from 'primevue/card';
import Button from 'primevue/button';
import IftaLabel from 'primevue/iftalabel';
import Password from 'primevue/password';
import Message from 'primevue/message';
import Dialog from 'primevue/dialog';
import { appendAlert } from '@/plugins/alert';

export default {
  name: 'ProfilePage',
  components: {
    Card,
    Button,
    IftaLabel,
    Password,
    Message,
    Dialog
  },
  data () {
    return {      
      inputError: '',
      nameField: '',
      loading: false,
      login: 'rr',
      userInfo: { name: "", email: ""},
      clubsList: null,
      isPasswordVisible: false,
      password: "",
      confirmPassword: "",
      isConfirmPasswordTouched: false,
      isValidationError: false,
      passwordValidateError: "" 
    }
  },

  watch: {
      $currentUser(newVal, oldVal) {            
        this.userInfo = newVal
    }
  },

  methods: {
    async logout() {
        await AuthService.makeLogout()      
      },            

      getUserInfo() {
        this.userInfo = this.$currentUser
      },

      // async getUserInfo() {
      //   this.loading = true
      //  
      //   try {
      //       //const { data } = await UsersService.getById(this.$store.state.user.currentUser.id) 
      //       const { data } = await UsersService.getCurrent()             
      //       this.userInfo = data                               
      //   } catch (e) {            
      //       this.error = e.message
      //       console.log(e)
      //   } finally {
      //       this.loading = false
      //   }        
      // },

    async getClubsList() {
        this.loading = true
        
        try {
            const { data } = await ClubsService.getList()             
            this.clubsList = data.content                        
        } catch (e) {            
            this.error = e.message
            console.log(e)
        } finally {
            this.loading = false
        }
      },

    changePasswordVisibility() {
        this.isPasswordVisible = !this.isPasswordVisible
    },

    async changePassword() {
      if (!this.validateNewPassword()) return

      this.loading = true

      try {            
          const { data } = await UsersService.changePassword(this.password)                         

          appendAlert("Пароль успешно изменен", 'success');                 
          this.changePasswordVisibility()
          this.password = ""
          this.confirmPassword = ""
      } catch (e) {            
          this.error = e.message
          console.log(e)
      } finally {             
          this.loading = false
      }  
    },

    // Валидация перед отправкой
    validateNewPassword() {
      if (this.password !== this.confirmPassword) {
        this.isValidationError = true
        this.passwordValidateError = "Пароли не совпадают"
        return false
      }

      if (!this.password.trim()) {
        this.isValidationError = true
        this.passwordValidateError = "Пароль не заполнен"
        return false
      }

      if (this.password.length < 6) {
        this.isValidationError = true
        this.passwordValidateError = "Пароль должен быть не менее 6 символов"
        return false
      }
      
      return true
    },

    undoPasswordChange() {
      this.changePasswordVisibility()
      this.password = ""
      this.confirmPassword = ""
      this.passwordValidateError = ""
      this.isValidationError = false      
      this.isConfirmPasswordTouched = false
    },

    inputConfirmPassword() {
      this.isConfirmPasswordTouched = true
      this.validatePasswords()
    },

    // Валидация при вводе пароля
    validatePasswords() {
      if (this.password !== this.confirmPassword && this.isConfirmPasswordTouched) {
        this.isValidationError = true
        this.passwordValidateError = "Пароли не совпадают"
      } else {
        this.isValidationError = false
        this.passwordValidateError = ""
      }
    }

      
  },      

    mounted () {
      this.login = this.$store.getters['user/getLoginCurentUser']; 
      this.getUserInfo();
      this.getClubsList();
  } 
}
</script>

<style scoped>

.list-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
   background: inherit;
}

.table {
  background: inherit;
}

.elem{
  margin-right: 10px;
  margin-top: 10px;
}
</style>